import { CustomiseOrganisationProfile } from "../../../customise/CustomiseOrganisationProfile";



export const TrustCustomiseOrganisationalProfileContainer = () => {
    return (
        <CustomiseOrganisationProfile isTrust={true} />
    );
}